import { OptionItem } from '../option-item/option-item.tsx';
import { Combobox as BaseCombobox } from './combobox';
export * from './multi-combobox.tsx';
export * from './types.ts';
export * from './hooks/use-multi-options.ts';

export const Combobox = Object.assign(BaseCombobox, {
  Option: OptionItem
}); 